import React, { useCallback } from 'react';

import { isEmpty } from 'lodash';

import { Card, Container, MarginBottom } from './Styled';

import Text from 'components/Text';
import Button from 'components/Button';
import CardDisplay from 'components/common/Card';

import TextInput from 'components/TextInput';
import { context as valuesContext } from 'components/ValuesProvider';
import { ErrorMessage } from 'components/ErrorMessage';
import { ACCOUNT_DETAILS } from 'constants/errors';

import { accountValidator } from './validation';

const AccountDetails = ({ error, isLoadingDetails, userIsAdmin, updateAccount }) => {
  const saveHandler = useCallback((context) => {
    let values = context.getValues();
    let errors = accountValidator(values);

    let submitValues = Object
      .keys(values)
      .reduce((m, key) => ({ ...m, [key]: values[key] || '' }), {});

    isEmpty(errors) ? updateAccount(submitValues) : context.setErrors(errors);
  });

  const isDisabled = isLoadingDetails || !userIsAdmin;

  return (
    <Container>
      <Card height="100%">
        <MarginBottom>
          <CardDisplay.SubTitle>Account</CardDisplay.SubTitle>
          <Text.Info>Manage and update your account details</Text.Info>
        </MarginBottom>

        <TextInput
          bold
          name="name"
          context={valuesContext}
          label={'Name'}
          disabled={isDisabled}
          placeholder={`Enter account name`}
        />
        <TextInput
          bold
          name="address_line1"
          label={'Address Line 1'}
          context={valuesContext}
          disabled={isDisabled}
          placeholder={`Enter address line 1`}
        />
        <TextInput
          bold
          name="address_line2"
          label={'Address Line 2'}
          context={valuesContext}
          disabled={isDisabled}
          placeholder={`Enter address line 2`}
        />
        <TextInput
          bold
          name="address_suburb"
          label={'Suburb'}
          context={valuesContext}
          disabled={isDisabled}
          placeholder={`Enter address suburb`}
        />
        <TextInput
          bold
          name="address_state"
          label={'State'}
          context={valuesContext}
          disabled={isDisabled}
          placeholder={`Enter address state`}
        />
        <TextInput
          bold
          name="address_postcode"
          label={'Postcode'}
          context={valuesContext}
          disabled={isDisabled}
          placeholder={`Enter address postcode`}
        />

        {
          userIsAdmin &&
          <Button.Default
            inline
            label="Save"
            onClick={saveHandler}
            context={valuesContext}
            loading={isLoadingDetails}
            disabled={isDisabled}
          />
        }

        <ErrorMessage error={error} for={ACCOUNT_DETAILS} />
      </Card>
    </Container>
  );
};

export default AccountDetails;
